import detectTouch from '../../../../scripts/utilities/detect-touch';
import globals from '../../../../scripts/modules/globals';
import * as hammer from 'hammerjs';
import {element} from './constants';
import selection from '../utility/selection';

const createPlaceholderArray = () => {
	let output = [];
	element.links.forEach((link) => {
		if (link.classList.contains('is-current') && link.textContent) {
			output.push(link.textContent);
		}
	});
	return output;
}

const placeholder = () => {
	let arr = createPlaceholderArray();
	let noun = arr.length > 1 ? 'neighborhoods' : 'neighborhood';
	let selected = `(${arr.length}) ${noun} selected`;
	let none = 'Select your neighborhood(s)';
	element.input.innerHTML = arr.length ?  selected : none;
}

const categories = () => {
	element.categories.forEach( function( el ) {
		el.onclick = function() {
			if ( !el.classList.contains('is-current') ) {
				let current = document.querySelector('.search__button.is-current');
				current.classList.remove('is-current');
				el.classList.add('is-current');
			}
		};
	});
}

const submit = () => {
	let url = {
		category: '',
		parameters: '',
		options: []
	};
	element.submit.onclick = () => {
		element.categories.forEach( (button) => {
			if ( button.classList.contains('is-current') ) {
				url.category = button.getAttribute('data-id');
			}
		});
		element.links.forEach( (link) => {
			if ( link.classList.contains('is-current') ) {
				url.parameters += '&location[]=' + link.getAttribute('data-id');
			}
		});
		window.location = `${globals.url}/${url.category}?filter=true${url.parameters}`;
	}
}

export default function () {
	if (element.parent) {
		categories();
		submit();
		selection(element.listSelector, element.linkSelector, placeholder);
	}
}
